export const HIGHLIGHT_DATABASES = [
  "MitImpact (APOGEE)",
  "MitoTip",
  "MetaRNN",
  "CADD",
  "DANN",
  "dbscSNV",
];
